import { render, staticRenderFns } from "./cosDocDetailInfo.vue?vue&type=template&id=9dbd4cca&scoped=true"
import script from "./cosDocDetailInfo.vue?vue&type=script&lang=js"
export * from "./cosDocDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./cosDocDetailInfo.vue?vue&type=style&index=0&id=9dbd4cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbd4cca",
  null
  
)

export default component.exports